<div class="plan-table-container pb-4">

  <div class="plan-table-wrapper" [class.plan-body-scroll]="(isRegister || isAnalytics)">

    <table class="plan-table" [ngClass]="{'mt-5': isAnalytics}">

      <!-- COLUMN WIDTH CONTROL -->
      <colgroup>
        <col [ngClass]="(isRegister || isAnalytics) ? 'feature-col-register' : 'feature-col'" />
        <col *ngFor="let plan of plans" class="plan-col" />
      </colgroup>

      <!-- HEADER -->
      <thead>
        <tr [class.pd-right]="(isRegister || isAnalytics)">

          <th class="feature-cell"></th>

          <th *ngFor="let plan of plans" class="plan-header py-4"
            [class.active-plan]="!isRegister && plan.PlanUid === activePlanUid">

            <div class="label-wrapper" *ngIf="!isRegister && plan.PlanUid === activePlanUid">
              <span class="current-label fs-20">
                {{'your_plan' | translate}}
              </span>
            </div>

            <div class="fw-semibold syne-text fs-30 mt-2 plan-name">
              {{ plan.PlanName }}
            </div>

            <div class="fs-20 fw-medium mb-2 mt-1" *ngIf="!isRegister">
              {{ plan.PriceLabel }}
            </div>
            <button class="btn rounded-pill plan-btn fs-16 w-75 mt-3 p-2"
              [class.invisible]="plan.PlanUid === activePlanUid" (click)="selectPlan(plan)">
              {{ plan.IsFree == 1
              ? ('select_plan' | translate)
              : ('contact_us_plan' | translate)}}
            </button>

          </th>
        </tr>
      </thead>

      <!-- BODY -->
      <tbody>

        <tr *ngFor="let feature of featureRows; let i = index" [class.striped]="i % 2 === 0">

          <td class="feature-cell fw-semibold syne-text py-3 fs-20">
            {{ feature.label | translate }}
          </td>

          <td *ngFor="let plan of plans" class="plan-cell fs-16 text-center px-1 py-3"
            [class.active-plan]="!isRegister && plan.PlanUid === activePlanUid">

            <ng-container *ngIf="feature.render(plan) as result">
              <ng-container [ngSwitch]="result.type">

                <i *ngSwitchCase="'yes'" class="icon skf-yes"></i>
                <i *ngSwitchCase="'no'" class="icon skf-no"></i>

                <span *ngSwitchCase="'yes-text'" class="d-inline-flex align-items-center gap-1">
                  <i class="icon skf-yes"></i>
                  {{ result.value | translate:{count: result.count} }}
                </span>

                <span *ngSwitchCase="'text'" class="d-flex flex-column justify-content-center px-3">
                  {{ result.value | translate: result }}
                </span>

                <span *ngSwitchCase="'composite'" class="d-flex flex-column justify-content-center">
                  {{ result.countryKey | translate:{count: result.count} }}
                  <br>
                  {{ result.analyticsKey | translate: result }}
                </span>

              </ng-container>
            </ng-container>

          </td>
        </tr>

      </tbody>

    </table>

    <div class="plan-notes text-muted syne-text mt-3 ms-3 fs-15">
      <div class="mb-1">{{'plan_info_text1' | translate}}</div>
      <div class="mb-1">{{'plan_info_text2' | translate}}</div>
      <div class="mb-1">{{'plan_info_text3' | translate}}</div>
    </div>

  </div>
</div>


<div class="modal fade" id="requestSentBtnModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg rounded-4 p-4 px-5 position-relative">
      <button type="button" class="btn-close position-absolute end-0 top-0 m-3" data-bs-dismiss="modal"
        (click)="closePage()" aria-label="Close">
      </button>
      <span class="fs-32 syne-text mb-4 mt-4 fw-medium text-center mx-5">
        {{'thanks_for_contact' | translate}}
      </span>
      <span class="text-center fs-16 mb-4 small">
        {{'plan_contact_text' | translate}}
      </span>
      <div class="d-flex justify-content-center mb-4">
        <button class="btn w-50 home-btn fs-16 rounded-pill" type="submit" (click)="goToHome()">
          {{'return_home' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>